import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { Observable } from 'rxjs'
import { ToggleClass } from 'core/toggleClass';

export class ModalBemPanvelComponent {
    constructor() {
        this.modalSelector = document.querySelectorAll('[data-modal="bem-panvel"]')
        this.modalBemPanvel = document.querySelector('.modal-bem-panvel')
        this.validator = null

        this.modal = new ToggleClass({
          selector: this.modalSelector,
          target: this.modalBemPanvel,
          class: 'modal--active',
          callback: undefined,
          blockBodyScroll: true
        })

        this.init()
    }

    init() { }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-bem-panvel/modal-bem-panvel.component.js